export default __webpack_public_path__ + "static/media/sico_shoot_landscape_2.986c5e13.jpg";